import { 
  SHOW_LEFT_MENU, 
  HIDE_LEFT_MENU, 
  SET_LEFT_MENU_VISIBILITY,
  SET_PRIVATE_COLLECTIONS,
  SET_PUBLIC_COLLECTIONS,
  SET_CATEGORIES,
 } from '../actions/general'

const state = {
  leftMenuShown: false,
  privateCollections: ['private'],
  publicCollections: [],
  categories: [],
}

const getters = {
  isleftMenuShown(state) {
    return state.leftMenuShown
  },
  getPrivateCollections(state) {
    return state.privateCollections
  },
  getPublicCollections(state) {
    return state.publicCollections
  },
  getCategories(state) {
    return state.categories
  }
}

const mutations = {
  [SHOW_LEFT_MENU]: state => {
    state.leftMenuShown = true
  },
  [HIDE_LEFT_MENU]: state => {
    state.leftMenuShown = false
  },
  [SET_LEFT_MENU_VISIBILITY]: (state, value) => {
    state.leftMenuShown = value
  },
  [SET_PRIVATE_COLLECTIONS]: (state, value) => {
    state.privateCollections = value
  },
  [SET_PUBLIC_COLLECTIONS]: (state, value) => {
    state.publicCollections = value
  },
  [SET_CATEGORIES]: (state, value) => {
    state.categories = value
  },
}

export default {
  state,
  getters,
  mutations,
}